export default __webpack_public_path__ + "flags.5bc53ca7.png";